
import * as THREE from "../../libs/three.js/build/three.module.js";
import {LineMaterial} from "../../libs/three.js/lines/LineMaterial.js";
import {Geopackage, GeoPackageLoader} from "./GeoPackageLoader.js";
import * as toGeoJSON from "@mapbox/togeojson";

export class KMLLoader{

	static async loadBuffer(buffer, params){
		params = params || {};

		let transform = params.transform;
		if(!transform){
			transform = {forward: (arg) => arg};
		}

		const text = new TextDecoder().decode(buffer);
		const doc = new DOMParser().parseFromString(text, "text/xml");
		const geojson = toGeoJSON.kml(doc);
		const features = (geojson && geojson.features) || [];

		const kmlNode = new THREE.Object3D();
		kmlNode.name = params.source || "KML";
		kmlNode.potree = { source: params.source };

		const geo = new Geopackage();
		geo.path = params.source;
		geo.node = kmlNode;

		const zOffset = params.zOffset ?? 0;
		geo.zOffset = zOffset;
		kmlNode.position.z = zOffset;

		const matLine = new LineMaterial({
			color: new THREE.Color(0.9, 0.6, 0.1),
			linewidth: 2,
			resolution: new THREE.Vector2(1000, 1000),
			dashed: false,
		});

		const layerNode = new THREE.Object3D();
		layerNode.name = params.source || "KML";
		kmlNode.add(layerNode);

		for(const feature of features){
			if(!feature.geometry) continue;

			const type = feature.geometry.type;

			if(type === "Point" || type === "LineString" || type === "Polygon"){
				const featureNode = GeoPackageLoader.featureToSceneNode(feature, matLine, null, transform);
				if(featureNode) layerNode.add(featureNode);
			}else if(type === "MultiPoint"){
				for(const coords of feature.geometry.coordinates){
					const sub = {geometry: {type: "Point", coordinates: coords}};
					const node = GeoPackageLoader.featureToSceneNode(sub, matLine, null, transform);
					if(node) layerNode.add(node);
				}
			}else if(type === "MultiLineString"){
				for(const coords of feature.geometry.coordinates){
					const sub = {geometry: {type: "LineString", coordinates: coords}};
					const node = GeoPackageLoader.featureToSceneNode(sub, matLine, null, transform);
					if(node) layerNode.add(node);
				}
			}else if(type === "MultiPolygon"){
				for(const coords of feature.geometry.coordinates){
					const sub = {geometry: {type: "Polygon", coordinates: coords}};
					const node = GeoPackageLoader.featureToSceneNode(sub, matLine, null, transform);
					if(node) layerNode.add(node);
				}
			}else if(type === "GeometryCollection"){
				for(const geom of feature.geometry.geometries){
					const sub = {geometry: geom};
					const node = GeoPackageLoader.featureToSceneNode(sub, matLine, null, transform);
					if(node) layerNode.add(node);
				}
			}
		}

		return geo;
	}

};
